// Ordre d'affichage canonique des catégories de plats — toujours Entrée, Plat, Dessert en premier (ordre de
// service logique), les catégories personnalisées ensuite par ordre alphabétique. Utilisé partout où des
// plats sont groupés par catégorie (catalogue, Mode terrain, récap client) pour que l'ordre soit identique
// d'un bout à l'autre du module (le backend applique la même logique pour la page convive et la fiche
// technique cuisine, voir CATEGORY_DISPLAY_ORDER dans functions/api/[[path]].js). Demande explicite d'Emeni
// (2026-08-23) : "l'ordre sera toujours entrée plat et dessert, pour les choix, pour les récaps cuisine et
// client".
const CATEGORY_DISPLAY_ORDER = ['entrée', 'entree', 'plat', 'plat principal', 'dessert'];

export const categoryCompare = (a: string, b: string): number => {
    const ia = CATEGORY_DISPLAY_ORDER.indexOf((a || '').toLowerCase());
    const ib = CATEGORY_DISPLAY_ORDER.indexOf((b || '').toLowerCase());
    if (ia !== -1 && ib !== -1) return ia - ib;
    if (ia !== -1) return -1;
    if (ib !== -1) return 1;
    return (a || '').localeCompare(b || '', 'fr');
};

export const sortByCategoryOrder = (categories: string[]): string[] => categories.slice().sort(categoryCompare);
